@import "tailwindcss";

@plugin "@tailwindcss/typography";
@plugin "daisyui" {
    exclude: properties;
}
@plugin "daisyui/theme" {
    name: "spreewunder";
    default: true;
    prefersdark: false;
    color-scheme: light;
    --color-base-100: oklch(100% 0 0);
    --color-base-200: oklch(0.85 0.0048 197.03);
    --color-base-300: oklch(0.7 0.0048 197.03);
    --color-base-content: oklch(0.25 0.0068 286.05);
    --color-primary: oklch(0.8814 0.1917 109.44);
    --color-primary-content: oklch(0.25 0.0068 286.05);
    --color-secondary: oklch(0.4 0.0068 286.05);
    --color-secondary-content: oklch(1 0 0);
    --color-accent: oklch(0.6264 0.1408 242.13);
    --color-accent-dark: oklch(0.5 0.1408 242.13);
    --color-accent-content: oklch(1 0 0);
    --color-neutral: oklch(0.5965 0.0048 197.03);
    --color-neutral-content: oklch(1 0 0);
    --color-info: oklch(74% 0.16 232.661);
    --color-info-content: oklch(1 0 0);
    --color-success: oklch(0.67 0.165 131.8);
    --color-success-content: oklch(1 0 0);
    --color-warning: oklch(0.4887 0.2086 344.09);
    --color-warning-content: oklch(1 0 0);
    --color-error: oklch(0.5895 0.238 2.01);
    --color-error-content: oklch(1 0 0);
    --color-bundid-blue: oklch(0.538 0.1298 243.7);
    --radius-selector: 1rem;
    --radius-field: 1rem;
    --radius-box: 1rem;
    --size-selector: 0.25rem;
    --size-field: 0.25rem;
    --border: 1px;
    --depth: 1;
    --noise: 0;
    --font-primary: "Roboto", sans-serif;
    --font-display: "Roboto", sans-serif;
    --fonf-sans: "Roboto", sans-serif;
    --font-roboto: "Roboto", sans-serif;
    --default-font-family: "Roboto", sans-serif;
}

@theme {
    --color-base-100: oklch(100% 0 0);
    --color-base-200: oklch(0.85 0.0048 197.03);
    --color-base-300: oklch(0.7 0.0048 197.03);
    --color-base-content: oklch(0.25 0.0068 286.05);
    --color-primary: oklch(0.8814 0.1917 109.44);
    --color-primary-content: oklch(0.25 0.0068 286.05);
    --color-secondary: oklch(0.4 0.0068 286.05);
    --color-secondary-content: oklch(1 0 0);
    --color-accent: oklch(0.6264 0.1408 242.13);
    --color-accent-dark: oklch(0.5 0.1408 242.13);
    --color-accent-content: oklch(1 0 0);
    --color-neutral: oklch(0.5965 0.0048 197.03);
    --color-neutral-content: oklch(1 0 0);
    --color-info: oklch(74% 0.16 232.661);
    --color-info-content: oklch(1 0 0);
    --color-success: oklch(0.67 0.165 131.8);
    --color-success-content: oklch(1 0 0);
    --color-warning: oklch(0.4887 0.2086 344.09);
    --color-warning-content: oklch(1 0 0);
    --color-error: oklch(0.5895 0.238 2.01);
    --color-error-content: oklch(1 0 0);
    --color-bundid-blue: oklch(0.538 0.1298 243.7);
    --font-primary: "Roboto", sans-serif;
    --font-display: "Roboto", sans-serif;
    --fonf-sans: "Roboto", sans-serif;
    --font-roboto: "Roboto", sans-serif;
    --default-font-family: "Roboto", sans-serif;
}

@utility prose-spreewunder {
    @apply prose;
    & > * {
        --tw-prose-body: var(--color-base-content);
        --tw-prose-headings: var(--color-base-content);
        --tw-prose-invert-body: var(--color-base-200);
        --tw-prose-invert-headings: var(--color-info);
    }
}

/* roboto-200 - latin_latin-ext_math_symbols */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 200;
    src: url('./fonts/roboto-v49-latin_latin-ext_math_symbols-200.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* roboto-200italic - latin_latin-ext_math_symbols */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Roboto';
    font-style: italic;
    font-weight: 200;
    src: url('./fonts/roboto-v49-latin_latin-ext_math_symbols-200italic.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* roboto-regular - latin_latin-ext_math_symbols */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url('./fonts/roboto-v49-latin_latin-ext_math_symbols-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* roboto-italic - latin_latin-ext_math_symbols */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Roboto';
    font-style: italic;
    font-weight: 400;
    src: url('./fonts/roboto-v49-latin_latin-ext_math_symbols-italic.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* roboto-700 - latin_latin-ext_math_symbols */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    src: url('./fonts/roboto-v49-latin_latin-ext_math_symbols-700.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* roboto-700italic - latin_latin-ext_math_symbols */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Roboto';
    font-style: italic;
    font-weight: 700;
    src: url('./fonts/roboto-v49-latin_latin-ext_math_symbols-700italic.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
